export const CC_PALETTE = [
  { name: 'blu_agid', label: 'Blu Agid', code: '#0066CC' },
  { name: 'verde_agid', label: 'Verde Agid', code: '#007A52' },
  { name: 'verde_muschio', label: 'Verde muschio', code: '#476100' },
  { name: 'verde_prato', label: 'Verde prato', code: '#006600' },
  { name: 'turchese', label: 'Turchese', code: '#027B7B' },
  { name: 'bordeaux', label: 'Bordeaux', code: '#880123' },
  { name: 'prugna', label: 'Prugna', code: '#840668' },
  { name: 'viola', label: 'Viola', code: '#5A13C3' },
  { name: 'fuxia', label: 'Fuxia', code: '#C931B5' },
  { name: 'marrone', label: 'Marrone', code: '#8C3B08' },
  { name: 'oro', label: 'Oro', code: '#8A7000' },
  { name: 'blu_navy', label: 'Blu navy', code: '#01027F' },
];
